import React, { useEffect, useState } from 'react';
import { useAuthContext } from '../hooks/useAuthContext'; // Your authentication context
import { useParams, Link } from 'react-router-dom';
import { getDoc, doc } from 'firebase/firestore'; // Import Firestore functions
import { db } from '../firebase/config'; // Firestore instance
import './Hero.css'

const Hero = () => {
  const { user } = useAuthContext(); // Get authenticated user
  const { collectionId } = useParams(); // Assuming you're using react-router for collection routes

  const [collection, setCollection] = useState(null);

  useEffect(() => {
    const fetchCollection = async () => {
      try {
        // Get the document from Firestore
        const docRef = doc(db, 'collections', collectionId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setCollection(docSnap.data()); // Set collection data
        } else {
          console.log('No such collection!');
        }
      } catch (error) {
        console.error('Error fetching collection:', error);
      }
    };

    if (collectionId) {
      fetchCollection();
    }
  }, [collectionId]);

  if (!collection) return <div>Loading...</div>;

  return (
    <div className="hero-container">
      <div className="hero-background">
        <img
          src={collection.imageUrl}
          alt={collection.name}
        />
      </div>
      
      <div className="hero-content">
        <h1 className="hero-title">{collection.name}</h1>
        <p className="hero-description">{collection.description}</p>
  
        {user ? (
          <div></div>
        ) : (
          <Link to='/login'><button className="hero-button login-button">Log In to Shop</button></Link>
        )}
      </div>
    </div>
  );
};

export default Hero;
